import { TimeslotContent } from './timeslotContent'

export class Timeslot {
	public id: number
	public scheduleId: number
	public name: string
	public type: string
	public vevent: string
	public priority: number
	public timeslotContents: TimeslotContent[]

	constructor(data: {
		id: number
		scheduleId: number
		name: string
		type: string
		vevent: string
		priority: number
		timeslotContents: TimeslotContent[]
	}) {
		this.id = data.id
		this.scheduleId = data.scheduleId
		this.name = data.name
		this.type = data.type
		this.vevent = data.vevent
		this.priority = data.priority
		this.timeslotContents = data.timeslotContents
	}

	static create(data: Partial<Timeslot>): Timeslot {
		const defaultData = {
			id: 0,
			scheduleId: 0,
			name: '',
			type: '',
			vevent: '',
			priority: 0,
			timeslotContents: [],
		}

		return new Timeslot({
			...defaultData,
			...data,
		})
	}
}
